import { Icon } from './Icon'
import type { IconProps } from './Icon'

export const VolumeIcon = (p: IconProps) => <Icon {...p}><path d="M11 5 6 9H2v6h4l5 4V5z" /><path d="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07" /></Icon>
